// Size ids for the deal pop-up. A deal step lists the sizes it accepts (`step.sizes: [{id, label, price}]`); each product in the step lists
// the sizes it really has (`product.sizes: ['9737', ...]`, or nothing when the server did not say). A size the product does not have must never
// be sent to the cart: online the server takes the id as given, offline the engine refuses it.

const same = (a, b) => String(a) === String(b);
const productSizeIds = (product) => (Array.isArray(product?.sizes) && product.sizes.length > 0 ? product.sizes : null);

/** The step's sizes this product can be added in: only those it has, or all of them when the product's own sizes are not known. */
export function stepSizesForProduct(stepSizes, product) {
  const sizes = stepSizes || [];
  const own = productSizeIds(product);
  if (!own) return sizes;
  return sizes.filter((s) => own.some((id) => same(id, s.id)));
}

/**
 * The size to pre-select when a product is tapped: the first included (price 0) size that is BOTH in the step's list and in the product's own
 * sizes, else the first of those, else (no overlap at all) the product's own first size. With no step sizes there is nothing to choose: null.
 * With the product's sizes unknown it is the step's first included size, as before.
 */
export function defaultSizeId(stepSizes, product) {
  const sizes = stepSizes || [];
  if (sizes.length === 0) return null;
  const own = productSizeIds(product);
  const eligible = stepSizesForProduct(sizes, product);
  if (eligible.length > 0) return (eligible.find((s) => !s.price || s.price === 0) || eligible[0]).id;
  if (own) return own[0];
  return (sizes.find((s) => !s.price || s.price === 0) || sizes[0]).id;
}
